import { MemoizedSelector, createSelector } from '@ngrx/store';
import { Country } from '../../../model/address.model';
import { SiteContextState, StateWithSiteContext } from '../site-context-state';
import { getSiteContextState } from './site-context.selector';

export const getActiveCountry: MemoizedSelector<StateWithSiteContext, Country> = createSelector(
  getSiteContextState,
  (state: SiteContextState) => state.activeCountry
);
